import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Typography,
  Button,
  Avatar,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import useApiManager from "../../utils/Api/apiManager";

const EditUserProfile = ({ open, onClose }) => {
  const [userId, setUserId] = useState("userId");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("")
  const [profilePictureUrl, setProfilePictureUrl] = useState("");
  const [profilePictureAttachment, setProfilePictureAttachment] = useState(null);
  const { get, put } = useApiManager();

  const fetchUserData = async () => {
    try {
      const response = await get('/me'); // Fetch user info
      setUserId(response.id);
      setProfilePictureUrl(response.profilePictureUrl);
      setFirstName(response.firstName);
      setLastName(response.lastName);
      setEmail(response.email);
    } catch (error) {
      console.error('Error fetching user:', error);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, [open]);


  const handleProfilePictureChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Set the file for later upload
      setProfilePictureAttachment(file);
  
      // Create a temporary URL (data URL) for the image to preview it
      const reader = new FileReader();
      reader.onloadend = () => {
        // Set the profile picture URL to the data URL for immediate preview
        setProfilePictureUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  

  const handleEdit = async () => {
    const formData = new FormData();
    formData.append('attachment', profilePictureAttachment);

    const url = `/me/${userId}/`;

    const config = {
      params: {
        firstName,
        lastName
      },
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    };

    try {
      await put(url, formData, config);
      onClose();
    } catch (error) {
      console.error('Error editing profile:', error);
      // Handle error (e.g., show error message)
    }
  }

  const handleSave = async () => {
    handleEdit();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Edit Profile</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Box sx={{ position: "relative" }}>
            <Avatar
              src={
                profilePictureUrl?.startsWith("data:")
                  ? profilePictureUrl
                  : `${profilePictureUrl}?${new Date().getTime()}`
              }
              alt="Profile Picture"
              sx={{ width: 100, height: 100 }}
            />
            <IconButton
              color="primary"
              component="label"
              sx={{ position: "absolute", bottom: 0, right: 0 }}
            >
              <PhotoCamera />
              <input
                type="file"
                accept="image/*"
                hidden
                onChange={handleProfilePictureChange}
              />
            </IconButton>
          </Box>

          <TextField
            label="First Name"
            variant="outlined"
            fullWidth
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
          <TextField
            label="Last Name"
            variant="outlined"
            fullWidth
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
          <TextField
            disabled
            label="Email"
            variant="outlined"
            fullWidth
            value={email}
            InputProps={{ readOnly: true }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSave}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditUserProfile;